import React from 'react'
import { Link } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit'
import Box from '@material-ui/core/Box'
import CityPage from './../../../../Containers/City/Page'
import { getCityLink } from 'Utils/Link'
import { ACTION_EDIT } from 'constants.js'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'
import { styles } from './style'

import DistributionZonesComponent from 'Components/DistributionZonesComponent'

import injectStyles from 'react-jss'

const DistributionZonesPage = props => {
  const { nav, cityId, cityName, classes, history, match, country } = props

  return (
    <CityPage
      active={nav}
      cityId={cityId}
      history={history}
      match={match}
      cityName={cityName}
      breadcrumbs={[{ label: 'Distribution Zones' }]}
    >
      <Link to={getCityLink(cityId, ACTION_EDIT)} className="link-edit-main">
        <StyledIconButton>
          <EditIcon />
        </StyledIconButton>
      </Link>
      <Box className={classes.distributionZonesWrapper}>
        <DistributionZonesComponent cityId={cityId} country={country} />
      </Box>
    </CityPage>
  )
}

export default injectStyles(styles)(DistributionZonesPage)
